// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ryhmVWtBnlA5AZEm{position:absolute;left:8px;top:0;width:20px;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:flex-start;color:var(--py-neutral-9)}.S7gLlq6ryMOr379F{position:absolute;right:8px;top:0;width:20px;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:flex-start;color:var(--py-neutral-5);cursor:pointer;font-size:16px}.S7gLlq6ryMOr379F:hover{color:var(--py-neutral-7)}.UXjuzW3_wnoETvNI{margin-top:4px;display:flex;flex-wrap:wrap;row-gap:4px;column-gap:4px}.UXjuzW3_wnoETvNI .LHxKvhtUtE0NYyuG{padding-left:0px;padding-right:6px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchIcon": `ryhmVWtBnlA5AZEm`,
	"clearText": `S7gLlq6ryMOr379F`,
	"multiSelectOptions": `UXjuzW3_wnoETvNI`,
	"multiValueOption": `LHxKvhtUtE0NYyuG`
};
export default ___CSS_LOADER_EXPORT___;
